// extracted by mini-css-extract-plugin
export default {"main":"Contact_main__qnUlo","section1":"Contact_section1__vIYG-","section2":"Contact_section2__7ZWmv"};